function initSiteHeader(scope) {
  var headers = (scope || document).querySelectorAll('[data-site-header]');

  headers.forEach(function (header) {
    if (header.dataset.headerInit === 'true') return;
    header.dataset.headerInit = 'true';

    var toggleBtn = header.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    var closeBtn = drawer ? drawer.querySelector('[data-drawer-close]') : null;
    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchPanel = header.querySelector('[data-search-panel]');
    var searchClose = header.querySelector('[data-search-close]');
    var searchInput = header.querySelector('[data-search-input]');

    var lastFocused = null;

    function openDrawer() {
      if (!drawer || !overlay) return;
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('site-header-drawer-open');
      var firstLink = drawer.querySelector('.site-header__drawer-link, .site-header__drawer-close');
      if (firstLink) firstLink.focus({ preventScroll: true });
      document.addEventListener('keydown', onKeydown);
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('site-header-drawer-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus({ preventScroll: true });
    }

    function onKeydown(e) {
      if (e.key === 'Escape') closeDrawer();
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Search panel toggle
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var isOpen = searchPanel.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen && searchInput) {
          window.setTimeout(function () {
            searchInput.focus();
          }, 200);
        }
      });
    }

    if (searchClose && searchPanel) {
      searchClose.addEventListener('click', function () {
        searchPanel.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initSiteHeader(document);
});

document.addEventListener('shopify:section:load', function (event) {
  var header = event.target.querySelector('[data-site-header]');
  if (header) header.dataset.headerInit = '';
  initSiteHeader(event.target);
});